import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Scadenza } from '../../../models/scadenza';

@Component({
    selector: '[add_doc_to_scadenza]',
  templateUrl: 'add-to-scadenza.component.html',
})

export class AddDocumentoToScadenzaComponent {
  @Input()
  scadenza: Scadenza;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(scadenza: Scadenza) {
    this.onClickAddToEntity.emit(scadenza);
  }
}
